import React from 'react';
import { connect } from 'react-redux';
import ReactEcharts from '../lazy/Echarts';
import { dateTime, graphDateString } from '../../utils/parsing';
import { zip, max } from '../../utils/collections';
import { ECHARTS_COLORS } from '../../redux/constants/colors';

const getOption = ({ labels, series, timestamps, latest }) => ({
  title: {
    text: 'Analytic Execution Stats',
    subtext: `Last run completed @ ${dateTime(latest)}`,
  },
  tooltip: {
    trigger: 'axis',
  },
  legend: {
    type: 'scroll',
    orient: 'horizontal',
    data: labels,
    top: '90%',
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '10%',
    containLabel: true,
  },
  xAxis: {
    type: 'time',
    boundaryGap: false,
    data: timestamps,
  },
  yAxis: [
    {
      type: 'value',
      position: 'left',
    },
    {
      type: 'value',
      position: 'right',
      name: 'ms',
    },
  ],
  color: ECHARTS_COLORS,
  series,
});

const runtimeMs = (exec) => new Date(exec.finished) - new Date(exec.started);

/**
 * A graph of analytics stats for all analytics in the current page
 *
 * NB: the viewer only shows the first page right now, so this will need updating
 */
const AnalyticsGraph = (props) => {
  if (props.isEmpty) return null;
  return <ReactEcharts option={getOption(props)} notMerge />;
};

export default connect((state) => {
  const {
    analytics: {
      executions: { byId },
      results,
    },
  } = state;
  // finished runs only for now, since we're graphing runtime
  const stats = Object.values(byId).filter((s) => !!s.finished);
  const timestamps = stats.map((s) => graphDateString(s.finished));
  const latest = max(timestamps);
  const makeData = (func) => zip(timestamps, stats.map(func));
  const series = [
    { name: 'Succeeded?', type: 'scatter', data: makeData((e) => e.succeeded) },
    { name: 'Schedule', symbol: 'none', type: 'scatter', data: makeData((e) => e.schedule_id) },
    // TODO: right now these numbers don't load until you click through the table
    { name: 'Points', type: 'scatter', data: makeData((e) => results[e.id]?.OUT?.keys.points) },
    {
      name: 'Timeseries',
      type: 'scatter',
      data: makeData((e) => results[e.id]?.OUT?.keys.timeseries),
    },
    {
      name: 'Processing Time (ms)',
      type: 'scatter',
      yAxisIndex: 1, // values are much larger, use a separate axis
      data: makeData(runtimeMs),
    },
  ];
  const labels = series.map((s) => s.name);
  return {
    labels,
    series,
    timestamps,
    latest,
    isEmpty: stats.length === 0,
  };
})(AnalyticsGraph);
